import { render, staticRenderFns } from "./AutoReplyRules.vue?vue&type=template&id=74bfd0e6&scoped=true"
import script from "./AutoReplyRules.vue?vue&type=script&lang=js"
export * from "./AutoReplyRules.vue?vue&type=script&lang=js"
import style0 from "./AutoReplyRules.vue?vue&type=style&index=0&id=74bfd0e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfd0e6",
  null
  
)

export default component.exports